"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/WFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_250)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_250`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.16003 0H33.84V24H-2.16003V0Z",
					fill: "#D80B30"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.16003 0H2.63997V10.6392H-2.16003V0Z",
					fill: "#00318A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.64001 0H7.44001V10.6392H2.64001V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.16003 10.6392H12.9V0",
					stroke: "white",
					strokeWidth: .72
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.7792 10.3896L18.9504 5.56079H28.6104L23.7792 10.3896ZM22.1712 12L17.34 7.17119V16.8312L22.1712 12ZM23.7792 13.6104L18.9504 18.4392H28.6104L23.7792 13.6104ZM25.3896 12L30.2208 7.16879V16.8288L25.3896 12Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_250`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as WFFlag };
